import { Map } from "core-js";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
    openEditDeposit: false,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};